<script setup></script>
<template>
  <main>
    <h3>一、 活动名称：</h3>
    <p>积分赢好礼</p>
    <h3>二、活动时间：</h3>
    <p>自2024年5月1日12时00分起至2024年5月31日23时59分止</p>
    <h3>三、参与资格：</h3>
    <p>1、您应年满18周岁，具有完全民事行为能力。</p>
    <p>
      2、本活动不鼓励未满18周岁的未成年用户参与。若您为不具备完全民事行为能力的未成年人，您应在监护人的陪同下阅读本规则，并取得您监护人的同意。如您监护人同意您参与本活动，应对您参与本活动期间作出的行为进行正确监督和引导同时，您行使和履行本活动规则下的权利和义务，均视为已获得您监护人认可，请理性消费。
    </p>
    <p>
      3、活动期间，每个自然人每天可参与10次活动（每日零点重新计算），且仅可使用自己合法有权的有效账号参与活动，如使用自己名下多个账号或使用他人账号您的全部参与行为将被视为无效，且无权获得任何奖品。
    </p>
    <h3>四、活动规则：</h3>
    <p>1、抽奖资格获取：仅企鹅汇图用户可使用积分进行抽奖。</p>
    <p>
      2、抽奖活动：活动期间，您可以在本活动页面参与抽奖活动，每次抽奖消耗1积分，抽奖结果即时显示。
    </p>
    <p>3、奖项设置本活动奖品明细为：</p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;1）Apple iPad mini 8.3英寸平板电脑 2021年新款(64GB）星光色 1份，中奖概率0.001%；
    </p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;2）联想（Lenovo）T6X投影仪2份，中奖概率0.005%；
    </p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;3）华为手环7NFC版 5份，中奖概率0.01%；</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;4）企鹅汇图10积分200份，中奖概率10%；</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;5）企鹅汇图5积分500份，中奖概率15%；</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;6）企鹅汇图3积分1000份，中奖概率20%；</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;7）企鹅汇图1积分2000份，中奖概率30%；</p>
    <p>
      4、奖品数量及概率：奖品数量如明细所示，抽完即止。上述中奖概率均为对应奖品的独立中奖概率，所用概率均是在大样本(大量用户)下的统计数值，与单个用户的少量测试数据之间可能会存在一定差异，本次活动非100%中奖。
    </p>
    <p>5、 奖品查询与发放</p>
    <p>（1）抽奖奖品请在我的中奖记录中查看；</p>
    <p>（2）您的抽奖记录可在积分明细页面进行查看；</p>
    <p>（3）奖品的发放：</p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;A、获得实物奖的用户请填写奖品邮寄地址（备注：姓名、联系电话、联系地址等），活动期间内未填写地址视为放弃奖品，不予邮寄，兑奖且成功填写信息的用户，奖品将在您填写地址后的20个工作日内邮寄，请注意查收。实物奖的用户无需承担邮寄运费。收到奖品后需要当面拆开，确认实物奖品的完整性。若由于获奖者自身原因（包括但不限于错填/漏填收件地址及联系方式、未在收到奖品后当面验收确认）导致获奖者无法按活动规则实际享有该奖品的，视为获奖者自愿放弃获奖，腾讯公司将不会给予获奖者任何形式的补偿。
    </p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;B、获得积分奖的用户，获奖积分将于2个工作日内到账，您需要在企鹅汇图APP→积分福利中进行领取，获奖积分有效期同企鹅汇图积分规则中有效期规则一致，即自积分下发日起，有效期365天，过期自动清零，请您合理安排使用。
    </p>
    <p>
      我们会采取安全的技术措施保护您的信息安全，且仅会将您的信息与第三方物流公司共享，以完成必要的配送功能。
    </p>
    <p>
      6、凡属腾讯免费邮寄的奖品，腾讯在寄送之前均会对奖品进行检查，保证奖品不存在损坏情形，寄送过程中若有损坏，请您联系物流公司协商有关赔偿事宜，与腾讯无关。
    </p>
    <h3>五、参与资格、获奖资格的取消</h3>
    <p>
      您若有下列任何一种行为或情况的，腾讯有权单方面取消您的参与资格、获奖资格等。
    </p>
    <p>（一）不符合参与资格的；</p>
    <p>（二）提供虚假信息的；</p>
    <p>（三）虚假交易或恶意破坏活动的；</p>
    <p>
      （四）以任何机器人软件、蜘蛛软件、爬虫软件、刷奖软件或其它任何自动方式、不正当手段等参与本活动的；
    </p>
    <p>（五）有任何违反诚实信用，公序良俗、公平、公正等原则行为的；</p>
    <p>（六）其他违反相关法规、本规则行为的。</p>
    <p>
      请用户理性参与活动，活动期间，如用户存在违反法律．法规或违反包括但不限于《企鹅汇图软件许可及服务协议》及活动合作平台规则，包括但不限于以作弊等非正当方式获取奖品、积分等行为，腾讯公司有权取消用户中奖资格，撒销违规交易，收回奖品或权益。如有疑问，请联系企鹅汇图吐小巢咨询相关事宜。
    </p>
    <h3>六、纳税义务</h3>
    <p>主办方将依法履行个人所得税等相关税费代扣代缴的义务。</p>
    <h3>七、免责条款</h3>
    <p>
      如因非腾讯原因导致您在本规则约定时间内未参与活动、兑换奖品或领取奖品，或由于您提供的信息不真实不完整等导致奖品无法发放或发放错误的，由您自行承担全部损失。互联网运行存在诸多不确定性因素，如因不可抗力、网络、通讯线路故障、计算机大规模瘫痪及活动中存在大面积作弊行为等原因致使本活动出现异常情况或难以继续开展的，腾讯有权采取包括但不限于通过各种方式消除异常情况或调整、暂停、取消本活动等合理措施保障腾讯及用户的合法权益，您表示理解，由此给您造成的损失，您同意不追究腾讯的责任。
    </p>
    <h3>八、管辖条款</h3>
    <p>
      本规则的成立、生效、履行、解释及纠纷解决等相关事宜，均适用中华人民共和国大陆地区法律（不包括冲突法）。若您和腾讯之间发生任何纠纷或争议应将纠纷或争议提交本规则签订地即深圳市南山区有管辖权的人民法院管辖。
    </p>
  </main>
</template>
<style scoped lang="scss">
main {
  padding: 20px 25px;
  max-height: calc(100vh - 80px);
  overflow: auto;
}
h3 {
  font-size: 16px;
  color: #17181a;
}
p {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.8);
}
</style>
